export default __webpack_public_path__ + "static/media/SWT0570.34I-18868_-19845_0.df3d3b85.jpg";